export default "/kiban/_next/static/images/minLand-7ff054065f2f01fa5003d0df0d9b2727.png";